import Image from "next/image";

import { FC } from "react";

import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Card } from "sections/nfcTagsPage/FeaturesSection";

import styles from "./styles";

interface ModalProps {
  isOpen: boolean;
  handleClose: () => void;
  item?: Card;
}

const FeaturesModal: FC<ModalProps> = ({ isOpen, handleClose, item }) => {
  return (
    <Dialog
      sx={{
        "&.MuiDialog-root": styles.modalRoot,
        "& .MuiDialog-paper": styles.modal,
        "& .MuiDialogContent-root": { p: 0 },
      }}
      open={isOpen}
      keepMounted
      onClose={handleClose}
    >
      <DialogContent>
        {item && (
          <Box sx={styles.wrapper}>
            <Container sx={styles.container}>
              <IconButton
                aria-label="close-modal"
                onClick={handleClose}
                sx={styles.closeButton}
              >
                <ArrowBackIcon fontSize="large" sx={styles.arrow} />
              </IconButton>

              <Typography variant="h1" component="h2" sx={styles.title}>
                {item.title}
              </Typography>
              <Box display="flex">
                <Typography variant="h3" sx={styles.details}>
                  {item.details}
                </Typography>
                <Box sx={styles.imageWrapper}>
                  <Image
                    src={item.imageModal || item.image}
                    width={355}
                    height={430}
                    alt=""
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      height: "auto",
                      float: "right",
                      maxWidth: 380,
                    }}
                  />
                </Box>
              </Box>
            </Container>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FeaturesModal;
